import React from 'react';
import { Artwork } from '../../types';
import { Search } from 'lucide-react';
import { useTranslation } from 'react-i18next';

interface GalleryGridProps {
  artworks: Artwork[];
  onArtworkClick: (artwork: Artwork) => void;
}

const GalleryGrid: React.FC<GalleryGridProps> = ({ artworks, onArtworkClick }) => {
  const { t } = useTranslation();

  return (
    <div className="columns-1 sm:columns-2 lg:columns-3 gap-4 space-y-4">
      {artworks.map((artwork) => (
        <div
          key={artwork.id}
          className="relative group break-inside-avoid cursor-pointer overflow-hidden rounded-xl art-card border-white/5"
          onClick={() => onArtworkClick(artwork)}
        >
          <img
            src={artwork.imageUrl}
            alt={t(`artworks.${artwork.id}.title`)}
            className="w-full h-auto object-cover transition-transform duration-500 group-hover:scale-105"
            loading="lazy"
          />
          
          {/* Overlay */}
          <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex flex-col justify-end p-4">
            <div className="flex justify-between items-baseline">
              <h3 className="text-white font-bold text-lg truncate pr-2">{t(`artworks.${artwork.id}.title`)}</h3>
              <span className="text-xs font-semibold text-white/70 whitespace-nowrap">{artwork.date}</span>
            </div>
            <div className="flex gap-2 mt-1">
              {artwork.tags.slice(0, 2).map(tag => (
                <span key={tag} className="text-[10px] uppercase font-bold text-brand-amber bg-black/50 px-1.5 py-0.5 rounded">
                  #{t(`tags.${tag}`, { defaultValue: tag })}
                </span>
              ))}
            </div>
            
            {/* Zoom Icon */}
            <div className="absolute top-4 right-4 w-8 h-8 rounded-full bg-white/20 backdrop-blur flex items-center justify-center text-white opacity-0 group-hover:opacity-100 transition-all translate-y-2 group-hover:translate-y-0">
              <Search className="w-4 h-4" />
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default GalleryGrid;
